module.exports = function getResource(label, vars = []) {
    let resources = {
        hairColor: 'Hair color',
        hairType: 'Hair type',
        hairConcerns: 'Hair concerns',
        selectOne: 'select one',
        selectAllType: 'select all that apply'
    };

    return resources[label];
};
